import React from 'react';
import InputFile from './input-file/InputFile';

const UploadMultiFile = ({ value, onChange, accept = 'image/*,.pdf,.doc,.docx,.xls,.xlsx,.zip,.rar', labelImage }) => {
    let parsedValues = [];
    if (value) {
        if (typeof value === 'string') {
            try {
                parsedValues = JSON.parse(value);
            } catch (e) {
                parsedValues = [];
            }
        } else if (Array.isArray(value)) {
            parsedValues = value;
        }
    }

    const handleChange = (files) => {
        // files is an array of file objects from InputFile.
        // Filter out those that have been successfully uploaded and map to their url
        const urls = files.filter(f => f.url).map(f => f.url);
        onChange(JSON.stringify(urls));
    };

    return (
        <div className="upload-multi-file-wrapper border p-3 rounded bg-light">
            <label className="d-block font-weight-bold mb-2 text-secondary">
                <i className="fas fa-paperclip mr-2 text-primary" />
                Tài liệu / Minh chứng đính kèm
            </label>
            <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
                <InputFile
                    multiple={true}
                    values={parsedValues}
                    enableReinitialize={true}
                    onChange={handleChange}
                    accept={accept}
                    labelImage={labelImage}
                />
            </div>
            <small className="form-text text-muted">
                Hỗ trợ tải lên nhiều file cùng lúc (Hình ảnh, PDF, Word, Excel...). Nhấn "Chọn file" để thêm mới tài liệu minh chứng.
            </small>
        </div>
    );
};

export default UploadMultiFile;
